import api from './api'

export const inventoryService = {
  getAll: (params?: { product_id?: string; status?: string; search?: string; page?: number; limit?: number }) =>
    api.get('/inventory', { params }),

  getMovements: (params?: { product_id?: string; type?: string; start_date?: string; end_date?: string }) =>
    api.get('/inventory/movements', { params }),

  getLowStock: () =>
    api.get('/inventory/low-stock'),

  adjustStock: (data: Array<{ product_id: number; serial_id?: number; quantity: number; reason: string; notes?: string }>) =>
    api.post('/inventory/adjust', data),

  getValuation: () =>
    api.get('/inventory/valuation'),
}
